import {
  REQ_TYPE_PRIVATE,
  REQ_TYPE_PRIVATE_NM,
  REQ_TYPE_COMMON,
  REQ_TYPE_COMMON_NM
} from "../constants/commonConstant";

// 가격 콤마 포맷: 1234567 → "1,234,567". 빈 값은 "0".
export const formatPrice = n => (n ? Number(n).toLocaleString() : "0");

// 날짜 표시 포맷: "2026.07.08". 사용자용 화면에서 timestamp 원문 노출 방지.
export const formatDate = d => {
  if (!d) return "";
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return "";
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const dd = String(dt.getDate()).padStart(2, "0");
  return `${dt.getFullYear()}.${mm}.${dd}`;
};

// 상태 코드 → 한글 라벨 + semantic-ui Label 색.
export const STATUS_INFO = {
  REQUEST:  { text: "구매신청", color: "yellow" },
  APPROVAL: { text: "구매승인", color: "blue" },
  RECEIPT:  { text: "도서수령", color: "green" },
  CANCLE:   { text: "신청취소", color: "grey" },
  REJECT:   { text: "구매반려", color: "red" }
};

export const statusToKorean = status =>
  STATUS_INFO[status] ? STATUS_INFO[status].text : "";

export const reqTypeToKorean = reqType => {
  if (reqType === REQ_TYPE_PRIVATE) return REQ_TYPE_PRIVATE_NM;
  if (reqType === REQ_TYPE_COMMON) return REQ_TYPE_COMMON_NM;
  return "";
};

// 명명 엔티티 → 실제 문자 (숫자 참조 &#40; 외에 지원할 최소 집합).
const NAMED_ENTITIES = {
  amp: "&",
  lt: "<",
  gt: ">",
  quot: '"',
  apos: "'",
  nbsp: " "
};

// 한 번(single pass) 디코딩: &#40; / &#x28; (10·16진) + 명명 엔티티만 치환.
// 미지원 엔티티는 원문(m) 그대로 둔다.
const decodeEntitiesOnce = s =>
  s.replace(/&(#x[0-9a-fA-F]+|#\d+|[a-zA-Z][a-zA-Z0-9]*);/g, (m, body) => {
    if (body[0] === "#") {
      const code =
        body[1] === "x" || body[1] === "X"
          ? parseInt(body.slice(2), 16)
          : parseInt(body.slice(1), 10);
      if (Number.isNaN(code)) return m;
      try {
        return String.fromCodePoint(code);
      } catch (e) {
        return m; // 코드포인트 범위 밖 등은 원문 유지
      }
    }
    const named = NAMED_ENTITIES[body.toLowerCase()];
    return named !== undefined ? named : m;
  });

// HTML 엔티티 디코딩: "&#40;" → "(", "&lt;" → "<" 등.
// 크롤링 도서명이 엔티티로 인코딩돼 유입되는 경우 실제 문자로 복원한다.
// 이중 인코딩(&amp;#40;) 대비 고정점 반복(최대 3회).
// React 가 출력 시 재escape 하므로 텍스트로 렌더하면 XSS 안전.
export const decodeEntities = input => {
  if (input === null || input === undefined) return input;
  let s = typeof input === "string" ? input : String(input);
  for (let i = 0; i < 3; i += 1) {
    const next = decodeEntitiesOnce(s);
    if (next === s) break;
    s = next;
  }
  return s;
};
